import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Tabs,
  Tab,
  Grid,
  Box,
  Avatar,
  Typography,
  Divider,
  Paper,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  LocationOn as LocationOnIcon,
  Lock as LockIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import ProfileSettings from "./UI/reusable-components/ProfileComponents/ProfileSettings";
import AddressSettings from "./UI/reusable-components/ProfileComponents/AddressSettings";
import PasswordChange from "./UI/reusable-components/ProfileComponents/PasswordChjange";
import CompanySettings from "./UI/reusable-components/ProfileComponents/CompanySettings";
import { GetProfile } from "../redux/actions/profileActions";
import user from "../assets/images/logos/user.png";
import MarketPlacesAccount from "./UI/reusable-components/ProfileComponents/MarketPlacesAccount";
import EcommercePlaceAccount from "./UI/reusable-components/ProfileComponents/EcommercePlaceAccount";
import InvoiceIntegratorAccount from "./UI/reusable-components/ProfileComponents/InvoiceIntegatorAccount";
import OrderPrintSettings from "./UI/reusable-components/ProfileComponents/OrderPrintSettings";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>{children}</Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `settings-tab-${index}`,
    "aria-controls": `settings-tabpanel-${index}`,
  };
}
const Profile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [tabValue, setTabValue] = useState(0);
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getProfileDetail = async () => {
    try {
      const response = await dispatch(GetProfile(authUserId, token));
      setFormValues({
        firstName: response.firstName,
        lastName: response.lastName,
        phone: response.phone || "",
        email: response.email,
      });
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    getProfileDetail();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 1, sm: 2, md: 3 },
        paddingTop: { xs: 4, sm: 5, md: 6 },
      }}
    >
      {/* İlk Kısım: Profil ve Sekmeler */}
      <Grid container spacing={{ xs: 2, sm: 3 }}>
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 2,
              backgroundColor: "#ffffff",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar
              src={user}
              alt="User Avatar"
              sx={{
                width: { xs: 80, sm: 100, md: 120 },
                height: { xs: 80, sm: 100, md: 120 },
                mb: { xs: 1, sm: 2 },
                border: "3px solid #1976d2",
              }}
            />
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 1,
                fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                textAlign: "center",
              }}
            >
              {formValues.firstName} {formValues.lastName}
            </Typography>
            <Stack spacing={1} width="100%" alignItems="center">
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "#555",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  wordBreak: "break-word",
                  textAlign: "center",
                }}
              >
                <EmailIcon
                  sx={{
                    mr: 1,
                    color: "#1976d2",
                    fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  }}
                />
                {formValues.email}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "#555",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
              >
                <PhoneIcon
                  sx={{
                    mr: 1,
                    color: "#1976d2",
                    fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  }}
                />
                {formValues.phone}
              </Typography>
            </Stack>
          </Paper>
        </Grid>

        <Grid item xs={12} md={9}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 1, sm: 2 },
              borderRadius: 2,
              backgroundColor: "#ffffff",
              height: { xs: "auto", md: "600px" },
              minHeight: { xs: "500px", md: "600px" },
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Tabs */}
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant={isMobile ? "scrollable" : "fullWidth"}
              scrollButtons={isMobile ? "auto" : false}
              textColor="primary"
              indicatorColor="primary"
              sx={{
                mb: 0,
                "& .MuiTab-root": {
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  minHeight: { xs: 48, sm: 64 },
                  padding: { xs: "6px 8px", sm: "12px 16px" },
                },
              }}
            >
              <Tab
                icon={
                  <PersonIcon
                    sx={{
                      color: "#1976d2",
                      fontSize: { xs: "1.1rem", sm: "1.25rem" },
                    }}
                  />
                }
                label="Profil Ayarları"
                iconPosition="start"
              />
              <Tab
                icon={
                  <BusinessIcon
                    sx={{
                      color: "#1976d2",
                      fontSize: { xs: "1.1rem", sm: "1.25rem" },
                    }}
                  />
                }
                label="Şirket"
                iconPosition="start"
              />
              <Tab
                icon={
                  <LocationOnIcon
                    sx={{
                      color: "#1976d2",
                      fontSize: { xs: "1.1rem", sm: "1.25rem" },
                    }}
                  />
                }
                label="Adresler"
                iconPosition="start"
              />
              <Tab
                icon={
                  <LockIcon
                    sx={{
                      color: "#1976d2",
                      fontSize: { xs: "1.1rem", sm: "1.25rem" },
                    }}
                  />
                }
                label="Şifre Değiştir"
                iconPosition="start"
              />
            </Tabs>

            {/* İçerik */}
            <Box
              sx={{
                width: "100%",
                flex: 1,
                overflowY: "auto",
                p: { xs: 1, sm: 2 },
              }}
            >
              {tabValue === 0 && (
                <ProfileSettings
                  formValues={formValues}
                  setFormValues={setFormValues}
                />
              )}
              {tabValue === 1 && <CompanySettings />}
              {tabValue === 2 && <AddressSettings />}
              {tabValue === 3 && <PasswordChange email={formValues.email} />}
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* İkinci Kısım: MarketPlacesAccount ve EcommercePlaceAccount */}
      <Paper
        elevation={3}
        sx={{
          mt: { xs: 2, sm: 3 },
          borderRadius: 2,
          backgroundColor: "#ffffff",
          minHeight: { xs: "auto", sm: "850px" },
          height: "auto",
          display: "flex",
          flexDirection: "column",
          overflow: "visible",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="settings tabs"
            variant={isMobile ? "scrollable" : "fullWidth"}
            scrollButtons={isMobile ? "auto" : false}
            sx={{
              "& .MuiTab-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                minHeight: { xs: 48, sm: 64 },
                padding: { xs: "6px 8px", sm: "12px 16px" },
              },
            }}
          >
            <Tab
              label={isMobile ? "Pazaryeri" : "Pazaryeri Platformları Ayarları"}
              {...a11yProps(0)}
            />
            <Tab
              label={isMobile ? "E-ticaret" : "E-ticaret Platformları Ayarları"}
              {...a11yProps(1)}
            />
            <Tab
              label={isMobile ? "Fatura" : "Fatura Ayarları"}
              {...a11yProps(2)}
            />
            <Tab
              label={isMobile ? "Sipariş" : "Sipariş Ayarları"}
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <MarketPlacesAccount />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <EcommercePlaceAccount />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <InvoiceIntegratorAccount />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <OrderPrintSettings />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default Profile;
